import React, { Fragment } from 'react'
import { MainButton, MainButtonWithSave } from '@newageerp/v3.bundles.buttons-bundle';
import { useListTableRow } from '@newageerp/v3.bundles.app-bundle';
import { useUSave } from '@newageerp/v3.bundles.hooks-bundle';

interface Props {
    fieldKey: string,
}

export default function PaymentRefundRequestStatusChange(props: Props) {
    const { element } = useListTableRow();
    const [saveData] = useUSave('payment-refund-request');

    const onRetry = async () => {
        await saveData({
            status: 0
        }, element.id);
        await saveData({
            status: 10
        }, element.id);
    };

    if (element.status === 10) {
        return <MainButton
            color='sky'
            onClick={onRetry}
        >
            Retry
        </MainButton>
    }

    if (element.status !== 0) {
        return <Fragment />
    }

    return (
        <div className='flex gap-2'>
            <MainButtonWithSave
                elementId={element.id}
                saveData={{
                    status: 10
                }}
                schema={"payment-refund-request"}
                color='teal'
                confirmation={true}
            >
                Confirm
            </MainButtonWithSave>

            <MainButtonWithSave
                elementId={element.id}
                saveData={{
                    status: 20
                }}
                schema={"payment-refund-request"}
                color='pink'
                confirmation={true}
            >
                Decline
            </MainButtonWithSave>
        </div>
    )
}
